var map = {
	"./ar-SA.md": 1799,
	"./be-BY.md": 1800,
	"./bg-BG.md": 1801,
	"./bn-BD.md": 1802,
	"./cs-CZ.md": 1803,
	"./da-DK.md": 1804,
	"./de-DE.md": 1805,
	"./el-GR.md": 1806,
	"./en-GB.md": 1807,
	"./en-US.md": 987,
	"./es-ES.md": 1808,
	"./fi-FI.md": 1809,
	"./fr-FR.md": 1810,
	"./he-IL.md": 1811,
	"./hi-IN.md": 1812,
	"./hr-HR.md": 1813,
	"./hu-HU.md": 1814,
	"./id-ID.md": 1815,
	"./it-IT.md": 1816,
	"./ja-JP.md": 1817,
	"./km-KH.md": 1818,
	"./ko-KR.md": 1819,
	"./me-ME.md": 1820,
	"./mk-MK.md": 1821,
	"./ne-NP.md": 1822,
	"./nl-NL.md": 1823,
	"./no-NO.md": 1824,
	"./pl-PL.md": 1825,
	"./pt-BR.md": 1826,
	"./pt-PT.md": 1827,
	"./pt-TL.md": 1828,
	"./ro-RO.md": 1829,
	"./ru-MD.md": 1830,
	"./ru-RU.md": 1831,
	"./sh-HR.md": 1832,
	"./si-LK.md": 1833,
	"./sk-SK.md": 1834,
	"./sr-CS.md": 1835,
	"./sr-ME.md": 1836,
	"./sr-RS.md": 1837,
	"./sr-SP.md": 1838,
	"./sv-SE.md": 1839,
	"./th-TH.md": 1840,
	"./tr-TR.md": 1841,
	"./tu-TI.md": 1842,
	"./uk-UA.md": 1843,
	"./ur-PK.md": 1844,
	"./vi-VN.md": 1845,
	"./zh-CN.md": 1846,
	"./zu-ZA.md": 1847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1798;